import {
  Grid,
  Typography,
  CardHeader,
  Card,
  CardContent
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getUserService } from "../services/loginService";
import { setUserData } from "../features/authSlice";
import InviteUser from "./inviteUser";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.auth.value.user);
  const [dialogOpen, toggleDialog] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    async function getData() {
      const res = await getUserService();
      if (!res.name) {
        navigate("/app/newUser");
      }
      dispatch(setUserData(res));
    }
    getData();
  }, [dispatch, navigate]);

  const profileRows = [
    { label: "Name", value: userData.name },
    { label: "Email", value: userData.email },
    { label: "Phone Number", value: userData.phone_number },
  ];

  return (
    <Grid container sx={{ p: { xs: 2, md: 3 } }} spacing={2}>
      <InviteUser dialogOpen={dialogOpen} handleClose={toggleDialog} />
      <Grid item xs={12}>
        <Typography variant="h4">Dashboard</Typography>
      </Grid>
      <Grid item xs={12} md={6}>
        <Card variant="outlined">
          <CardHeader title="Profile" />
          <CardContent>
            <Grid container rowSpacing={1.5}>
              {profileRows.map((row) => (
                <Grid item xs={12} key={row.label} container>
                  <Grid item xs={5}>
                    <Typography variant="body2" color="text.secondary">
                      {row.label}
                    </Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography variant="body1">{row.value || "—"}</Typography>
                  </Grid>
                </Grid>
              ))}
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default Dashboard;
